// src/components/RevenueTrendsChart.tsx

import React from 'react';
import { Card } from 'antd';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { ChartData } from './Dashboard';

interface RevenueTrendsChartProps {
  data: ChartData[];
}

const RevenueTrendsChart: React.FC<RevenueTrendsChartProps> = ({ data }) => {
  const yAxisTicks = [0, 50000, 60000, 70000, 80000, 90000];

  return (
    <Card title="Revenue Trends" extra={<span className="text-sm text-gray-500">Last 5 month</span>} className="shadow-none border border-gray-100">
      <div style={{ width: '100%', height: 300 }}>
        <ResponsiveContainer>
          <AreaChart data={data} margin={{ top: 10, right: 0, left: 10, bottom: 0 }}>
            <defs>
              <linearGradient id="colorRevenue" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#ef4444" stopOpacity={0.5} /> {/* Red color from image */}
                <stop offset="95%" stopColor="#ef4444" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} />
            <YAxis
              domain={[50000, 100000]}
              ticks={yAxisTicks}
              tickFormatter={(value) => `${value / 1000}K`}
              axisLine={false}
              tickLine={false}
            />
            <Area
              type="monotone"
              dataKey="value"
              stroke="#ef4444" // Red line color
              fill="url(#colorRevenue)"
              strokeWidth={2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default RevenueTrendsChart;